import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { queryKeys } from './queryKeys';

export function useAppCharges(appId) {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.charges.byApp(appId),
    queryFn: async () => {
      const response = await authFetch(`/api/apps/charges?appId=${appId}`);
      if (!response.ok) throw new Error('Failed to load charges');
      const data = await response.json();
      return data.charges || [];
    },
    enabled: !!appId,
  });
}
